import React, { Component, PropTypes } from 'react';

const css = oxygenCss({});

class StoreFilterModuleEditor extends Component {
  static propTypes = {
    id: PropTypes.string
  };

  render() {
    return <div className={css.root} />;
  }
}

export default StoreFilterModuleEditor;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/Modules/StoreFilterModuleEditor.js